var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessoru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 0.25H3.75C2.09315 0.25 0.75 1.59315 0.75 3.25V19C0.75 19.4142 1.08579 19.75 1.5 19.75H15C15.4142 19.75 15.75 19.4142 15.75 19C15.75 18.5858 15.4142 18.25 15 18.25H2.25C2.25 17.4216 2.92157 16.75 3.75 16.75H16.5C16.9142 16.75 17.25 16.4142 17.25 16V1C17.25 0.585786 16.9142 0.25 16.5 0.25ZM15.75 15.25H3.75C3.22326 15.2493 2.70572 15.388 2.25 15.6522V3.25C2.25 2.42157 2.92157 1.75 3.75 1.75H15.75V15.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessoru);
export default __webpack_public_path__ + "static/media/professoru.1bf4f867bea28718dddcda9c771cabe2.svg";
export { ForwardRef as ReactComponent };